import global from "@/global";
import { createResourceService } from "@/query//createResourceService";
import { UserAccount } from "@/resources/types";

const { dataProvider, queryClient, client } = global;

export const userService = createResourceService<UserAccount>({
  resource: "users",
  client,
  dataProvider,
  queryClient,
});